<template>
<div class="row">
    <div style="background:#055396;color:#fff;width: 100%;padding: 10px;
    margin: 0px 15px;">Update Tax Components 
    <span style="cursor:pointer;float:right;" 
    @click="close()">&#10006;</span></div>
<div style="padding:15px 15px 15px 15px;">
    <div style="font-weight: bold;padding-left: 15px;">Address Details</div>
      <div class="row" style="margin:0px;padding:0px">
      <div class="col-12"><div>Address line</div>
      <input v-model="regOfcStreetAddr" class="form-control" maxlength="200"
      placeholder="Minimum 10 characters"/></div>   
      <div class="col-3"><div>Country</div>
      <select v-model="countrycode" class="form-control" disabled="disabled">
      <option v-for="c in countryList" :key="c" :value="c.value">{{c.text}}</option>
      </select></div>   
      <div class="col-3"><div>State</div>
      <select v-model="regOfcState" class="form-control" @change="getCityForRegdOffice(regOfcState)"
      :class="stateList.length > 0 ? '': 'disabled'">
      <option v-for="s in stateList" :key="s" :value="s.value">{{s.text}}</option>
      </select></div>
      <div class="col-3"><div>City</div>
      <select v-model="regOfcCity" class="form-control" :class="cityList.length > 0 ? '': 'disabled'">
      <option v-for="c in cityList" :key="c" :value="c.value">{{c.text}}</option>
      </select></div>   
      <div class="col-3"><div>Zip Code</div>
      <input v-model="regOfcPin" class="form-control" :maxlength="countrycode==100 ? 6:15" 
      @keypress="isNumber($event, newMobile)"/>
      </div>
      </div>

      
          <div style="text-align:center;">
            <button @click="saveAddress()" style="margin: 5px;"
             class="btn btn-primary">Save Address</button>
          </div>
      <hr>
      <div style="font-weight: bold;padding-left: 15px;margin-top:10px;"
      v-if="gstList.length>0 || vatList.length>0">
        {{ countrycode == 100 ? 'Available GSTs:' : 'VAT Details:'}}</div>
        <div>
          <div class="table table-responsive" style="padding: 0px 15px;" 
          v-if="gstList.length>0 && countrycode == 100">        
            <table class="table-bordered" style="width: 100%;"> 
            <tr>
<th>GST Number</th>
<th>State</th>
<th>Registration Type</th>
<th></th>
</tr>
     <template v-for="(item,index) in gstList" >
  <tr @click="show_hide_row('hidden_row'+index);" :key="index" style="background:#e9e9e9;">
  <td>{{item.gstinNumber}}</td>
  <td>{{item.state}}</td>
  <td>{{item.typeOfRegistration}}</td><td>
    <span style="cursor:pointer; color:blue;text-decoration:underline;">Details</span>
    </td></tr>
<tr :id="'hidden_row'+index" class="hidden_row" :key="index">
<td colspan=4>
<div class="row">
<div class="col-12"><span class="bld">GST Registration Date:</span> {{item.gstRegistrationDate}}</div>
<div class="col-12"><span class="bld">GST Effective Upto:</span> {{item.gstGstEffectiveDate}}</div>
<div class="col-12"><span class="bld">Threshold Value:</span> {{item.thresholdTurnoverLimit}}</div>
<div class="col-12" v-if="item.typeOfRegistration == 'Vertical Registration'">
<span class="bld">GST Category Code:</span> {{item.categoryCode}}</div>
<div class="col-12" v-if="item.typeOfRegistration == 'Vertical Registration'">
<span class="bld">GST Sub Category Code:</span> {{item.subCategoryCode}}</div>
<div class="col-12"><span class="bld">Is Active:</span> {{item.isActive}}</div>
<div class="col-12"><span class="bld">Attachment: </span> &nbsp;<a
    @click="showAttachFile(form.gstDocumentId)"
    href="#">{{getFileName(form.gstDocumentId)}}</a>
</div>
<div class="col-12"><span class="bld">dealerType:</span> {{item.dealerType}}</div>
<div class="row" v-if="item.dealerType != 'Resident' && item.dealerType != 'Composition'"
style="padding-left: 30px;">
<div class="col-12"><span class="bld">Origin Country:</span> {{item.secondLevel.originCountry}}</div>
<div class="col-12"><span class="bld">Origin State:</span> {{item.secondLevel.originState}}</div>
<div class="col-12"><span class="bld">Work Country:</span> {{item.secondLevel.workCountry}}</div>
<div class="col-12"><span class="bld">Work State:</span> {{item.secondLevel.workState}}</div>
<div class="col-12"><span class="bld">Registration Number:</span> {{item.secondLevel.registrationNumber}}</div>
<div class="col-12"><span class="bld">Effective Date:</span> {{item.secondLevel.effectiveDate}}</div>
</div>
</div>
</td>
</tr>
     </template>


            </table>
          </div>
        </div>
      <div class="row" style="margin:0px;padding:0px;background: #f0f8ff;" 
      v-if="countrycode==100 && (gstList.length == 0 || addnewgstclicked)">
      <div style="padding-left: 15px;font-weight: bold;">Add New GST</div>
      
  <div class="col-12 ml-1">
  

            <p class="m-0 p-0 pt-1 partner-reg">GST State</p>
            <w-drop-down
              class="width-control-small"
              :options="gststatelist"
              @dropdownChange="getResgisteredGstState($event)"
              :selected="form.stateCode"
            />
          </div>
          <b-form-group class="ml-4 text-left" label>
            <b-form-radio-group v-model="selectedRType" :options="options"></b-form-radio-group>
          </b-form-group>
          <div class="col-12" v-if="selectedRType == 'V'">
            <div class="row">
              <div class="col-6">
                <p class="m-0 p-0 pt-1 partner-reg">Business Category</p>
                <w-drop-down
                  class="width-control-small"
                  :options="businessCategory"
                  @dropdownChange="getBusinessCategoryValue($event)"
                  :selected="form.categoryCode"
                />
              </div>
              <div class="col-6">
                <p class="m-0 p-0 pt-1 partner-reg">Business Sub-Category</p>
                <w-drop-down
                  class="width-control-small"
                  :options="businessSubCategory"
                  :disabled="!form.categoryCode"
                  @dropdownChange="getBusinessSubCategoryValue($event)"
                  :selected="form.subCategoryCode"
                />
              </div>
            </div>
          </div>
          <w-text-input
            class="text-left col-12 ml-1"
            :labelName="$t('GST Number')"
            @textInputChange="getGstNumber($event)"
            validation="required|regex_gst"
            :defaultValue="form.gstNumber"
            :maxCharacter="'50'"
          />
          <p
            class="mt-n2 ml-4 font-weight-bold text-danger lato-regular"
            v-if="gstDuplicate == true"
          >GST Number is already used</p>
          <div class="row ml-2">
            <w-datepicker
              class="text-left col-5"
              :inputLabel="'GST registration date'"
              :inputPlaceholder="$t('select date')"
              :errorMessage="''"
              :dateRange="''"
              @inputChange="getGSTRegisterDate($event)"
              :v-validate="'required'"
              :gstDateValidator="3"
              :defaultValue="form.gstRegistrationDate"
            />
            <div class="text-left col-5">
              <!-- <p class="p-0 m-0 pb-1 lato-regular field-headings">GST Effective From</p> -->
              <w-datepicker
                class="text-left"
                :inputLabel="'GST Effective From'"
                :inputPlaceholder="$t('select date')"
                :errorMessage="''"
                :dateRange="''"
                @inputChange="getGSTEffectiveFromDate($event)"
                :v-validate="'required'"
                :gstDateValidator="3"
                :defaultValue="form.gstEffectiveFrom"
              />
              <!-- <date-picker
                v-model="selectedDateRange"
                range
                :lang="'en'"
                confirm
                @confirm="gstEffectiveDate($event,i)"
                :format="'D-MMM-YYYY'"
                :shortcuts="false"
                :not-after="disableDateAfter"
                :not-before="disableDateBefore"
                class="w-100"
                :disabled="!form.gstRegistrationDate"
              ></date-picker>-->
            </div>
          </div>
          <w-text-input
            class="text-left col-4 ml-1"
            :labelName="$t('Threshold turnover limit')"
            @textInputChange="getTurnOver($event)"
            validation="required"
            :defaultValue="form.thresholdTurnoverLimit"
            :type="'number'"
            :maxCharacter="'8'"
          />
          <div class="col-4 ml-1 mb-3">
            <p class="m-0 p-0 pt-1 partner-reg">Type of Dealers</p>
            <w-drop-down
              class="width-control-small"
              :options="gstDealersDropDown"
              @dropdownChange="getGstDealersType($event)"
              :selected="form.dealerTypeCode"
            />
          </div>
        <div>          
      <FileUploader
        class="text-left ml-4"
        :id="'gstDocumentId'"
        :heading="'Attach Relevant GST documents/proofs *'"
        @fileInputChange="getGSTAttachment($event)"
      />
      <div class="col-12 ml-4 mt-1 p-0 pt-1" v-if="form.gstDocumentId">
        <ul style="list-style-type:disc;">
          <li>
            <a
              @click="showAttachFile(form.gstDocumentId)"
              href="#"
            >{{getFileName(form.gstDocumentId)}}</a>
          </li>
        </ul>
      </div>
        </div>
          <div class="mb-2" v-if="form.dealerTypeCode == 3 || form.dealerTypeCode == 4">
            <div class="row ml-1">
              <div class="col-5">
                <p class="m-0 p-0 pt-1 partner-reg">Orgin Country</p>
                <w-drop-down
                  class="width-control-small"
                  :options="countryDropDown"
                  @dropdownChange="getWorkRegisteredCountry($event)"
                  :selected="form.originCountryCode"
                />
              </div>
              <div class="col-5">
                <p class="m-0 p-0 pt-1 partner-reg">Orgin State</p>
                <w-drop-down
                  class="width-control-small"
                  :options="gstStateDropDown"
                  :disabled="!form.originCountryCode"
                  @dropdownChange="getWorkResgisteredGstState($event)"
                  :selected="form.originStateCode"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-5 ">
                <p class="m-0 p-0 pt-1 ml-1 pl-3 partner-reg">Work Country</p>
                <p class="m-0 p-0 pl-3 ml-1 partner-reg-subText">India</p>
              </div>
              <div class="col-5 ml-2 ">
                <p class="m-0 p-0 pt-1 partner-reg">Work State</p>
                <w-drop-down
                  class="width-control-small"
                  :options="gststatelist"
                  @dropdownChange="getGstWorkState($event)"
                  :selected="form.workStateCode"
                />
              </div>
            </div>
            <w-text-input
              class="text-left col-12 ml-1"
              :labelName="$t('Registration No.')"
              @textInputChange="getGstRegisterNumber($event)"
              validation="required"
              :defaultValue="form.registrationNumber"
              :maxCharacter="'15'"
            />
            <div class="row ml-2">
              <w-datepicker
                class="text-left col-5"
                :inputLabel="'Registration Date'"
                :inputPlaceholder="$t('select date')"
                :errorMessage="''"
                :dateRange="''"
                @inputChange="getRegisterDate($event)"
                :v-validate="'required'"
                :gstDateValidator="3"
                :defaultValue="form.registrationDate"
              />
              <div class="text-left col-5 ml-1">
                <!-- <p class="p-0 m-0 pb-1 lato-regular field-headings">GST Effective From to</p> -->
                <w-datepicker
                  class="text-left"
                  :inputLabel="'Effective From'"
                  :inputPlaceholder="$t('select date')"
                  :errorMessage="''"
                  :dateRange="''"
                  @inputChange="getEffectiveTimeFrom($event)"
                  :v-validate="'required'"
                  :gstDateValidator="3"
                  :defaultValue="form.effectiveFrom"
                />
                <!-- <date-picker
                  v-model="validityTimePeriod"
                  range
                  :lang="'en'"
                  confirm
                  @confirm="gstEffectiveTimePeriod($event,i)"
                  :format="'D-MMM-YYYY'"
                  :shortcuts="false"
                  :not-after="gstDisableDateAfter"
                  :not-before="gstDisableDateBefore"
                  class="w-100"
                  :disabled="!form.registrationDate"
                ></date-picker>-->
              </div>
            </div>
          </div>   
          </div>
          <div v-if="countrycode==100" style="text-align:center;">
          <p class="m-0 p-0" style="color:red;font-size:14px;">{{errorMessage}}</p>

            <button v-if="gstList.length != 0 && !addnewgstclicked" class="btn btn-secondary"
            @click="addmore()" style="margin: 5px;">+Add more GST</button>
            <button @click="saveOnboardingGST()" style="margin: 5px;"
            v-if="addnewgstclicked || gstList.length == 0"
             class="btn btn-primary">Save GST</button>
          </div>
            <div class="row" style="margin:0px;padding:0px;background: #f0f8ff;" 
            v-if="countrycode!=100 && !vatpresent">
            <div class="col-6" style="display: inline-block;"> 
              <div>Enter VAT number</div>
              <input type="text" class="form-control" v-model="vatNumber"
              placeholder="minimum 5 characters"/></div> 

              <div class="col-6" style="padding: 0px 15px;display: inline-block;">
                   <FileUploader :heading="'Attachment'"
                  @fileInputChange="UploadDocument($event, index, 'vat')"
                /> {{vatDocId}}
                <ul style="list-style-type:disc;" v-if="vatDocId">
                  <li>
                    <a
                      @click="showAttachFile(vatDocId)"
                      href="#"
                      class="mt-n2"
                    >{{getFileName(vatDocId)}}</a>
                  </li> 
                </ul></div>
            </div>            
          <div v-if="countrycode!=100 && !vatpresent" style="text-align:center;">           
            <button @click="saveVAT()" style="margin: 5px;"
             class="btn btn-primary">Save VAT</button>           
          </div>
          <div class="table table-responsive" style="padding: 0px 15px;" 
          v-if="countrycode!=100 && vatpresent">        
            <table class="table-bordered" style="width: 100%;"> 
            <tr>
              <th>VAT Number</th> 
              <th>Document</th>
            </tr>
            <tr>
              <td>{{vatList.vatNumber}}</td>
              <td><a
    @click="showAttachFile(vatList.vatDocumentNumber)"
    href="#">{{getFileName(vatList.vatDocumentNumber)}}</a></td></tr>
            </table>
          </div>
          <div style="color: orange;padding-left: 20px;" v-if="countrycode!=100 && vatpresent">
            * To modify VAT Details kindly complete profile or contact support</div>
          </div>
          </div>
</template>

<script>
import { PartnerService } from "../services/partnerService";
import { OnBoardingServices } from "../services/onBoardingService";
import { SummaryServices } from "../services/summaryService";
const OnBoardingService = new OnBoardingServices();
const partnerService = new PartnerService();
const summaryService = new SummaryServices();
import Modal from "../widgets/newModalWidget";
import TextInput from "../widgets/TextInput.vue";
import DropDown from "../widgets/DropDown";
import Datepicker from "../widgets/DatePicker";
import loadingSpinner from "../widgets/LoadingSpinner";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import partnertable from "../widgets/partner-table-collapsable";

import FileUploader from "../widgets/FileUploader";
export default {
  components: {
    "w-text-input": TextInput,
    "w-drop-down": DropDown,
    "w-datepicker": Datepicker,
    "w-collapse-table": partnertable,
    "w-loadingSpinner": loadingSpinner,
    DatePicker,
    "w-modal": Modal,
    FileUploader
  },
  props:["countrycode","companycode","categorycode","partnerid"],
  data() {
    return {
      selectedRType:'',
      addressObj:{},
      gstList: [],
      vatList:[],
      vatpresent:false,
      vatSiteUrl:'',
      vatDocId:'',
      vatNumber:'',
      addnewgstclicked: false,
      regOfcStreetAddr:"",
      regOfcCountry:"100",
      regOfcState:"",
      regOfcCity:"",
      regOfcPin:"",
      countryList:[],
      stateList:[],
      cityList:[],
      gstDuplicate: false,
      selectedDateRange: [],
      dismissCountDown: 0,
      dismissSecs: 5,
      errorMessage: "",
      disableDateBefore: "",
      disableDateAfter: "",
      validityTimePeriod: [],
      gstDisableDateAfter: "",
      gstDisableDateBefore: "",
      openModal: false,
      modeOfGST: "",
      gststatelist: [],
      gstOrginstatelist: [],
      gstStateDropDown: [],
      triggerModal: false,
      lastResponse: "",
      alertModal: false,
      successModal: false,
      categoryCode: "",
      options: [
        { text: "Single Registration", value: "S" },
        { text: "Vertical Registration", value: "V" }
      ],
      selected: "",
      stateCode: "",
      enableSubmit: true,
      loading: false,
      openTrackingModal: false,
      trackingDetails: [],
      roleName: [],
      form: {
        "categoryCode": null,
        "companyCode": 0,
        "dealerTypeCode": null,
        "documentNumber": "",
        "effectiveFrom": "",
        "effectiveUpto": "",
        "gstDocumentId": "",
        "gstEffectiveFrom": "",
        "gstEffectiveUpto": "",
        "gstNumber": "",
        "gstRegistrationDate": "",
        "originCountryCode": null,
        "originStateCode": null,
        "registrationDate": "",
        "registrationNumber": "",
        "registrationType": "",
        "siteUrl": "",
        "slNo": null,
        "stateCode": null,
        "subCategoryCode": null,
        "thresholdTurnoverLimit": null,
        "workCountryCode": 100,
        "workStateCode": null
        },
      state: {
        disabledDates: {
          from: "",
          to: ""
        }
      },
      gstTableDataList: {
        fields: [
          {
            key: "typeOfRegistration",
            label: "Registration Type",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "state",
            label: "State",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "gstinNumber",
            label: "GST Number",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "thresholdTurnoverLimit",
            label: "Threshold Limit",
            thClass: "thClassRight",
            tdClass: "text-right"
          },
          {
            key: "gstRegistrationDate",
            label: "Registration Date",
            thClass: "thClassCenter",
            tdClass: "text-center"
          },
          {
            key: "gstGstEffectiveDate",
            label: "GST Effective Period",
            thClass: "thClassCenter",
            tdClass: "text-center"
          },
          {
            key: "remarks",
            label: "Remarks",
            thClass: "thClassCenter",
            tdClass: "text-center"
          },
          {
            key: "dealerType",
            label: "Delear Type",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "toggle_icon",
            label: "",
            thClass: "table-action",
            tdClass: "text-center"
          }
        ],
        items: []
      },
      gstPendingTableDataList: {
        fields: [
          {
            key: "typeOfRegistration",
            label: "Registration Type",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "state",
            label: "State",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "gstinNumber",
            label: "GST Number",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "thresholdTurnoverLimit",
            label: "Threshold Limit",
            thClass: "thClassRight",
            tdClass: "text-right"
          },
          {
            key: "gstRegistrationDate",
            label: "Registration Date",
            thClass: "thClassCenter",
            tdClass: "text-center"
          },
          {
            key: "gstGstEffectiveDate",
            label: "GST Effective Period",
            thClass: "thClassCenter",
            tdClass: "text-center"
          },
          {
            key: "remarks",
            label: "Remarks",
            thClass: "thClassCenter",
            tdClass: "text-center"
          },
          {
            key: "dealerType",
            label: "Delear Type",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "toggle_icon",
            label: "",
            thClass: "table-action",
            tdClass: "text-left"
          }
        ],
        items: []
      },
      editModal: false,
      approvedEditList: false,
      partnerDetailsFilterText: "",
      gstDealersDropDown: [],
      countryDropDown: [
        { value: null, text: "Select Country", disabled: true }
      ],
      businessCategory: [],
      businessSubCategory: [],
      partnerDetailInfo: "",
      gstDocumentNumber: "",
      gstActionStatus: "",
      tempGstPendingDetails: [],
      createdCount: 0,
      pendingCount: 0,
      sentbackCount: 0,
      rejectedCount: 0
    };
  },  
  watch: {
    selectedRType: function() {
      this.form.categoryCode = null
      this.form.subCategoryCode = null
      }
  },
  created() {
    this.loading = true;
    //this.getpartnerDetails();
    this.getCountriesForRegdOffice();
    this.getGSTState();
    this.getGstDealers();
    this.getBusinessCategory();
    this.getAddress();
    if(this.countrycode==100){
      this.getOnboadingGST();
    } else {
      this.getOnboadingVAT();
    }
    this.form.companyCode = this.companycode
  },
  computed: {},
  methods: {
    addmore(){      
      var selector = "[id^='hidden_row']"
      $(selector).hide();
      this.addnewgstclicked=true
      this.selectedRType=''
      this.form = {
        "categoryCode": null,
        "companyCode": this.companycode,
        "dealerTypeCode": null,
        "documentNumber": "",
        "effectiveFrom": "",
        "effectiveUpto": "",
        "gstDocumentId": "",
        "gstEffectiveFrom": "",
        "gstEffectiveUpto": "",
        "gstNumber": "",
        "gstRegistrationDate": "",
        "originCountryCode": null,
        "originStateCode": null,
        "registrationDate": "",
        "registrationNumber": "",
        "registrationType": "",
        "siteUrl": "",
        "slNo": null,
        "stateCode": null,
        "subCategoryCode": null,
        "thresholdTurnoverLimit": null,
        "workCountryCode": 100,
        "workStateCode": null
        }
    },
    getOnboadingGST(){
    var self = this
      OnBoardingService.getOnboardingGSTList(this.companycode).then(resp => {
          if (resp.response) {
            self.gstList = resp.response
           }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getOnboadingVAT(){
    var self = this
    var data = {
      "categoryCode": this.categorycode,
      "companyCode": this.companycode,
      "partnerId": this.partnerid,
      "userId": 1
      }
      OnBoardingService.getOnboardingVATList(data).then(resp => {
          if (resp.response == "" && resp.failureMessage=='No vat details available') {
             self.vatpresent = false
           } else {
            self.vatList = resp.response
             self.vatpresent = true
           }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getAddress(){
    var self = this
      var data={   
        "categoryCode": this.categorycode,
        "companyCode": this.companycode,
        "partnerId": this.partnerid,
        "userId": 0
      }
      OnBoardingService.getOnboardingAddress(data).then(resp => {
          if (resp.response) {
            self.addressObj = resp.response[0]
            self.regOfcState = self.addressObj.stateCode
            self.regOfcCountry = self.addressObj.countryCode
            self.regOfcPin = self.addressObj.zipCode            
            self.regOfcStreetAddr = self.addressObj.streetAddress

            self.cityList = [];
      OnBoardingService.getCityForRegisteredOffice(self.addressObj.stateCode).then(resp => {
        resp.response.forEach(city => {
          self.cityList.push({
            text: city.cityName,
            value: city.cityCode
          });
        });
        
            self.regOfcCity = self.addressObj.cityCode
      });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    saveAddress(){   
     if (window.confirm("Do you want to save the Address?")) {
    var self = this   
    var data={
      "active": "Y",
      "cityCode": this.regOfcCity,
      "countryCode": this.countrycode,
      "id": {
      "addressTypeCode": 0,
      "categoryCode": this.categorycode,
      "companyId": this.companycode,
      "partnerId": this.partnerid,
      "slNo": 1
      },
      "insertedBy": 0,
      "insertedOn": "",
      "postalCode": this.regOfcPin,
      "stateCode": this.regOfcState,
      "streetAddress": this.regOfcStreetAddr,
      "updatedBy": 0,
      "updatedOn": ""
      }
     if(this.regOfcStreetAddr.trim().length<10 || !this.regOfcCountry ||
       !this.regOfcState || !this.regOfcCity 
       || (this.regOfcPin.trim().length < 6 && this.countrycode==100)
       || (this.regOfcPin.trim().length < 3 && this.countrycode!=100)) {
      window.alert("Kindly do mandatory checks and try again. \n-All fields are mandatory\n-Street Address length should be atleast 10 characters\n-Postal code should be valid")
     } else {
      OnBoardingService.saveOnboardingAddress(data).then(resp => {
          if (resp.failureMessage == '') {
            window.alert(resp.response)
            self.getAddress();
          } else {
            window.alert(resp.failureMessage)
          }
        })
        .catch(err => {
          console.log(err);
        });
     }
     }
    },
    saveOnboardingGST(){
      if (window.confirm("GST once saved cannot be edited. Do you want to save this GST?")) {

      var self = this
      this.form.registrationType = this.selectedRType
      var data = this.form
      data.companyCode = this.companycode
      this.errorMessage = ''
      
      if (!this.form.stateCode) {
        
        this.errorMessage = "Please select GST State";
        this.topFunction();
        return;
      }
      if (!this.form.registrationType) {
        
        this.errorMessage = "Please select your registration Type";
        this.topFunction();
        return;
      }
      if (this.form.registrationType == "V") {
        if (this.form.categoryCode == null) {
          
          this.errorMessage = "Select your Business Category";
          this.topFunction();
          return;
        }
        if (this.form.subCategoryCode == null) {
          
          this.errorMessage = "Select your Bussiness Sub-Category";
          this.topFunction();
          return;
        }
      }
      if (this.form.stateCode == this.form.workStateCode) {
        
        this.errorMessage = "GST State and Work state cannot be same";
        this.form.workStateCode = null;
        this.topFunction();
        return;
      }
      if (this.gstDuplicate == true) {
        
        this.errorMessage = "Please check the GST number";
        this.topFunction();
        return;
      }
      if (this.form.gstDocumentId == '') {
        
        this.errorMessage = "Please attach GST certificate";
        this.topFunction();
        return;
      }
      if (this.form.gstEffectiveFrom == '') {
        
        this.errorMessage = "Please select GST effective Upto";
        this.topFunction();
        return;
      }
      if (!this.form.dealerTypeCode) {
        
        this.errorMessage = "Please select Dealer Type";
        this.topFunction();
        return;
      }
      
      if (!this.form.thresholdTurnoverLimit) {
        
        this.errorMessage = "Please provide threshold value";
        this.topFunction();
        return;
      }
      if (!this.form.gstRegistrationDate) {
        
        this.errorMessage = "Please select GST Registration Date";
        this.topFunction();
        return;
      }
      
      if (this.form.dealerTypeCode==3 || this.form.dealerTypeCode==4) {
        if(!this.form.originCountryCode){
        this.errorMessage = "Please select origin country";
        this.topFunction();
        return;
        }
        if(!this.form.originStateCode){
        this.errorMessage = "Please select origin state";
        this.topFunction();
        return;
        }
        if(!this.form.workStateCode){
        this.errorMessage = "Please select work state";
        this.topFunction();
        return;
        }
        if(this.form.registrationNumber.trim().length==0){
        this.errorMessage = "Please provide Registration Number";
        this.topFunction();
        return;
        }
        if(!this.form.registrationDate){
        this.errorMessage = "Please provide Registration Date";
        this.topFunction();
        return;
        }
        if(!this.form.effectiveFrom){
        this.errorMessage = "Please provide Effective from date";
        this.topFunction();
        return;
        }
      }
      OnBoardingService.saveOnboardingGSTList(data).then(resp => {
          if (resp.failureMessage == '') {
            window.alert(resp.response)            
            self.getOnboadingGST()
            self.addnewgstclicked = false
          } else {
            window.alert(resp.failureMessage)
          }
          self.errorMessage = ''
        })
        .catch(err => {
          self.errorMessage = ''
          console.log(err);
        });
      }
    },
    saveVAT(){
      if(this.vatNumber.trim().length==0){
        window.alert('Vat Number is mandatory')
        return
      }
      if(!(/^[a-zA-Z0-9-]*$/.test(this.vatNumber.trim()))){
        window.alert('Vat Number must be alphanumeric')
        return
      }
      if(this.vatDocId.length==0 || this.vatSiteUrl.length==0){
        window.alert('VAT Document is Mandatory')
        return
      }
      if (window.confirm("VAT once saved cannot be edited. Do you want to save this VAT?")) {
      var self = this
      var data = {
            "categoryCode": this.categorycode,
            "companyCode": this.companycode,
            "partnerId": this.partnerid,
            "remarks": "",
            "userId": 1,
            "vatDocId": this.vatDocId,
            "vatNumber": this.vatNumber.trim(),
            "vatSiteUrl": this.vatSiteUrl
            }
      
      OnBoardingService.saveOnboardingVATList(data).then(resp => {
          if (resp.failureMessage == '') {
            window.alert(resp.response)            
            self.getOnboadingVAT()
            self.addnewgstclicked = false
          } else {
            window.alert(resp.failureMessage)
          }
          self.errorMessage = ''
        })
        .catch(err => {
          self.errorMessage = ''
          console.log(err);
        });
      }
    },
    show_hide_row(row){
      var id = '#'+row
      var selector = "[id^='hidden_row']:not("+id+")"
      $(selector).hide();
      var isVisible= $("#"+row).is(":visible")
      if(isVisible){
        $("#"+row).hide();
      } else if(!isVisible){
        $("#"+row).show();
      }
    },
    close(){
      this.$root.$emit('closeessential');
    },
    
    getFileName(fileName) {
      if (fileName == null) return "--";
      var fileNameFinal = "";
      fileNameFinal = fileName.split(/_(.+)/)[1];
      return fileNameFinal;
    },
    dateFormat(date) {
      return moment(date).format("Do MMM YYYY");
    },
    getCountriesForRegdOffice() {
      this.countryList = [];
      var self = this
      OnBoardingService.getCountriesForRegdOffice().then(resp => {
        resp.response.forEach(country => {
          this.countryList.push({
            text: country.longDesc,
            value: country.countryCode
          });
        });
        self.regOfcCountry=this.countrycode

        this.getStatesForRegdOffice();
      });
    },
    
    getStatesForRegdOffice() {
      this.stateList = [];
      OnBoardingService.getStatesForRegisteredOffice(
        this.countrycode
      ).then(resp => {
        resp.response.forEach(state => {
          this.stateList.push({
            text: state.longDescr,
            value: state.stateCode
          });
        });
      });
    },

    
    getCityForRegdOffice(stateCode) {
      this.cityList = [];
      OnBoardingService.getCityForRegisteredOffice(stateCode).then(resp => {
        resp.response.forEach(city => {
          this.cityList.push({
            text: city.cityName,
            value: city.cityCode
          });
        });
      });
    },

    isNumber(event, message) {
      if ((!/\d/.test(event.key) && this.countrycode == 100) 
      || (!/^[a-zA-Z0-9-]*$/.test(event.key) && this.countrycode != 100))   
        {   
        return event.preventDefault();  
      }
    },
    getBusinessCategory() {      
      if(this.countrycode == 100) {
      partnerService.getGstCategoriesOnboarding(this.companycode, this.categorycode).then(resp => {
        if (resp.response) {
          resp.response.forEach(data => {
            this.businessCategory.push({
              text: data.longDesc,
              value: data.categoryCode
            });
          });
        }
      });
      }
    },
    getBusinessSubCategory(code) {
      this.businessSubCategory = [];
      partnerService.getGstSubCategories(code, this.companycode).then(resp => {
        if (resp.response) {
          resp.response.forEach(data => {
            this.businessSubCategory.push({
              text: data.longDesc,
              value: data.categoryCode
            });
          });
        }
      });
    },

    getGSTState() {
      if(this.countrycode == 100) {
      partnerService
        .getStatesForGST(100)
        .then(resp => {
          if (resp.response) {
            resp.response.forEach(element => {
              this.gststatelist.push({
                text: element.longDescr,
                value: element.stateCode
              });
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
      }
    },
    getGstDealers() {
      if(this.countrycode == 100) {
      partnerService
        .gstDealers()
        .then(resp => {
          if (resp.response) {
            resp.response.forEach(element => {
              this.gstDealersDropDown.push({
                text: element.longDesc,
                value: element.dealerTypeCode
              });
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
      }
    },
    getBusinessCategoryValue(event) {
      //this.form.businessTypeCode = event;
      this.form.categoryCode = event;
      this.getBusinessSubCategory(event);
    },
    getBusinessSubCategoryValue(event) {
      //this.form.businessTypeCode = event;
      this.form.subCategoryCode = event;
    },

    getGstNumber(event) {
      this.form.gstNumber = event.toUpperCase();
      if (event.length > 14) {
        OnBoardingService.checkGSTNumber(event).then(resp => {
          if (resp.failureMessage == "Not Available") {
            this.gstDuplicate = true;
          }
        });
      } else {
        this.gstDuplicate = false;
      }
    },
    getGstRegisterNumber(event) {
      this.form.registrationNumber = event;
    },
    getGSTRegisterDate(event) {
      this.disableDateBefore = "";
      this.disableDateAfter = "";
      this.form.gstRegistrationDate = event;
      this.disableDateBefore = event;
      // var oneYearFromNow = new Date();
      // this.disableDateAfter = oneYearFromNow.setFullYear(
      //   oneYearFromNow.getFullYear() + 3
      // );
      // this.selectedDateRange = "";
      // this.form.gstEffectiveFrom = null;
      // this.form.gstEffectiveUpto = null;
    },
    getGSTEffectiveFromDate(event) {
      this.disableDateBefore = "";
      this.disableDateAfter = "";
      this.form.gstEffectiveFrom = event;
      this.disableDateBefore = event;
      //this.form.gstEffectiveFrom = event.toLocaleDateString();
    },
    topFunction() {
      $('.modal-body').scrollTop(0)
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    getRegisterDate(event) {
      this.gstDisableDateBefore = "";
      this.gstDisableDateAfter = "";
      this.form.registrationDate = event;
      // this.gstDisableDateBefore = event;
      // var oneYearFromNow = new Date();
      // this.gstDisableDateAfter = oneYearFromNow.setFullYear(
      //   oneYearFromNow.getFullYear() + 3
      // );
      // this.validityTimePeriod = "";
      // this.form.effectiveFrom = null;
    },
    getEffectiveTimeFrom(event) {
      this.form.effectiveFrom = event.toLocaleDateString();
    },
    // gstEffectiveDate(event) {
    //   this.selectedDateRange = event;
    //   this.form.gstEffectiveFrom = event[0].toLocaleDateString();
    //   this.form.gstEffectiveUpto = event[1].toLocaleDateString();
    // },
    // gstEffectiveTimePeriod(event) {
    //   this.validityTimePeriod = event;
    //   this.form.effectiveFrom = event[0].toLocaleDateString();
    //   this.form.effectiveUpto = event[1].toLocaleDateString();
    // },
    getResgisteredGstState(event) {
      this.form.stateCode = event;
    },
    getTurnOver(event) {
      this.form.thresholdTurnoverLimit = event;
    },
    getGstDealersType(event) {
      this.form.dealerTypeCode = event;
      if (event == 3 || event == 4) {
        this.getCountryList();
      }
    },
    getCountryList() {
      partnerService
        .getGstCountry()
        .then(resp => {
          if (resp.response) {
            resp.response.forEach(element => {
              if (element.countryCode != 100) {
                this.countryDropDown.push({
                  text: element.longDesc,
                  value: element.countryCode
                });
              }
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getWorkRegisteredCountry(event) {
      this.getGstOrginState(event);
      this.form.originCountryCode = event;
      this.form.originStateCode = null;
    },
    getGstOrginState(event) {
      this.gstStateDropDown = [];
      partnerService
        .getStatesForGST(event)
        .then(resp => {
          if (resp.response) {
            resp.response.forEach(element => {
              this.gstStateDropDown.push({
                text: element.longDescr,
                value: element.stateCode
              });
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getWorkResgisteredGstState(event) {
      this.form.originStateCode = event;
    },
    getGstWorkState(event) {
      this.form.workStateCode = event;
    },
    checkValidation() {
      if (
        this.form.stateCode &&
        this.form.thresholdTurnoverLimit &&
        this.form.gstEffectiveFrom &&
        this.form.gstNumber &&
        this.form.dealerTypeCode
      ) {
        if (this.form.dealerTypeCode == 3 || this.form.dealerTypeCode == 4) {
          if (
            this.form.effectiveFrom &&
            this.form.registrationNumber &&
            this.form.registrationDate &&
            this.form.workStateCode &&
            this.form.originCountryCode &&
            this.form.originStateCode
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    
    showAttachFile(event) {
      this.loading = true;
      OnBoardingService.downLoadDocument(event)
        .then(res => {
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        });
    },
    
    getGSTAttachment(event) {
      this.loading = true;
      this.formChanged = true;
      console.log(event[0]);
      let data = new FormData();
      let file = event[0];
      console.log(file);
      // data.append("name", "my-file");
      data.append("file", file);
      OnBoardingService.uploadAttachments(data).then(resp => {
        this.loading = false;
        if (resp) {
          this.form.gstDocumentId = resp.UniqueID;
          this.form.siteUrl = resp.SiteUrl;
        }
      });
    },
    
    UploadDocument(event,index,type) {
      let data = new FormData();
      let file = event[0];
      // data.append("name", "my-file");
      data.append("file", file);
      this.loading = true;
      OnBoardingService.uploadAttachments(data)
        .then(resp => {
          if (resp) {
            this.loading = false;
            if (type=='vat'){
            this.vatDocId = resp.UniqueID;
            this.vatSiteUrl = resp.SiteUrl;
            } 
          } else{            
          this.triggerModal = true;
          this.loading = false;
          this.lastResponse = "Something went wrong. Try After Sometime";
          this.alertsuccess = true;
          }
        })
        .catch(error => {
          this.loading = false;
          this.triggerModal = true;
          this.lastResponse = " Try After Sometime";
          this.alertsuccess = true;
        });
    },    
  }
};
</script>

<style scoped>
.orange-dot {
  height: 10px;
  width: 10px;
  background-color: orange;
  border-radius: 50%;
  display: inline-block;
}
.red-dot {
  height: 10px;
  width: 10px;
  background-color: #f43b3b;
  border-radius: 50%;
  display: inline-block;
}
.yellow-dot {
  height: 10px;
  width: 10px;
  background-color: #f4cf08;
  border-radius: 50%;
  display: inline-block;
}
.blue-dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  background-color: #002d72;
}
.card-background {
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
.search-bar .input-group-prepend .input-group-text {
  height: 38px;
  border-radius: 0;
  font-family: "Source Sans Pro", sans-serif;
  border: 1px solid #ced4da;
  background: #f4f4f4;
  font-size: 15px;
  cursor: pointer;
}

.search-bar .form-control {
  height: 38px;
  width: 30px !important;
  border-radius: 0;
  border: 1px solid #ced4da;
  font-size: 18px;
  font-family: "Source Sans Pro", sans-serif;
}

.search-bar .form-control:focus {
  box-shadow: none;
}
.search-bar {
  width: 30% !important;
}
.add-gst-button {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 600;
  border-color: none !important;
  width: 130px !important;
}
.sumbit-approval {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff !important;
  border-color: none !important;
}
.save-gst-button {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 500;
  border-color: none !important;
  color: #ffffff !important;
  width: 164px;
  /* width: 130px !important; */
}
.save-gst-button:disabled {
  cursor: not-allowed;
}
.partner-reg {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 15px;
  text-align: left;
  color: #696969;
}
.partner-reg-subText {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  color: #212529;
}
.sub-heading-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #212529;
}
.action-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: bold;
  color: #939393;
}
</style>
<style >
.modal-header {
  padding: 5px !important;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.modal-title {
  /* font-family: "Source Sans Pro", sans-serif !important; */
  font-size: 16px !important;
  font-weight: 500;
  color: #ffffff;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
  overflow-x: hidden;
}
.modal-footer {
  padding: 8px;
  /* margin-left: 4%;
  margin-right: 5%; */
  border-top: 1px solid #dee2e6;
  font-family: "Source Sans Pro", sans-serif;
}
/* .modal-footer > .btn-primary {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 500;
  border-color: none !important;
  color: #ffffff !important;
  width: 164px;
  margin-right: 2%;
} */

.custom-control-input:checked ~ .custom-control-label > span {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 15px !important;
  font-weight: bold;
  text-align: left;
  color: #002d72 !important;
}
.custom-control-input ~ .custom-control-label > span {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 15px !important;
  /* font-weight: bold; */
  text-align: left;
  /* color: #002d72 !important; */
}
.approved-gst {
  /* width: 23%; */
  /* float: left; */
  height: 18px !important;
}
.alertText {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
  font-size: 18px;
  text-align: center !important;
}
.modal-header .close {
  margin-top: 1px !important;
  padding: 0rem 0rem 0px !important;
  margin: -1rem -1rem -1rem auto;
  border: solid 1px #707070;
  /* color: rgba(0, 0, 0, 0.85); */
  font-family: "Source Sans Pro", sans-serif;
  color: red;
  border-radius: 50%;
  background-color: #ffff;
  margin: 0.5px 0px 0px 5px !important;
  width: 18px;
  font-size: 17px;
  font-weight: bold;
  opacity: unset !important;
}
</style>
<style>
.thClassLeft {
  background-color: #6192b1;
  color: white;
  text-align: left !important;
}
.thClassright {
  background-color: #6192b1;
  color: white;
  text-align: right !important;
}

.thClassCenter {
  background-color: #6192b1;
  color: white;
  text-align: center !important;
}
.table-action {
  background-color: #6192b1;
  width: 7% !important;
}
/* .dottedGreen {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #28b915;
  float: left;
  margin-top: 3%;
}
.dottedPending {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #f4cf08;
  float: left;
  margin-top: 7%;
}
.dottedRejected {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #e61313;
  float: left;
  margin-top: 3%;
}
.dottedSendback {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #002d72;
  float: left;
  margin-top: 3%;
} */

.hidden_row
{
 display:none;
}
.bld{
  font-weight:bold;
}
.vdp-datepicker input {
  background:#fff !important
}
</style>